<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

@if (!isLoading) {
<div class="mat-elevation-z2">
  <mat-accordion displayMode="flat">
    <section class="header-row">
      <div class="header-cell nine-cell center-self">
        <button mat-icon-button (click)="addOrEditScoringCategory(null)" style="outline: none; margin-left: 20px;"
          title="Add Scoring Category" [disabled]="!canEdit">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
        <span style="margin-left: 20px;">Description</span>
      </div>
      <div class="header-cell one-cell center-text center-self">Order</div>
      <div class="header-cell one-cell center-text center-self">First Move</div>
      <div class="header-cell one-cell center-text center-self">Last Move</div>
    </section>
    @for (scoringCategory of scoringCategoryList; track scoringCategory) {
    <mat-expansion-panel [expanded]="editScoringCategoryId === scoringCategory.id">
      <mat-expansion-panel-header class="row" (click)="togglePanel(scoringCategory.id); $event.stopPropagation()">
        <div class="cell nine-cell">
          <button mat-icon-button (click)="addOrEditScoringCategory(scoringCategory); $event.stopPropagation()"
            style="outline: none;" title="Edit Scoring Category" [disabled]="!canEdit">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteScoringCategoryRequest(scoringCategory); $event.stopPropagation()"
            style="outline: none;" title="Delete Scoring Category" [disabled]="!canEdit">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
          <span class="center-self">
            {{ scoringCategory.description }}
          </span>
        </div>
        <div class="one-cell center-text center-self">
          {{ scoringCategory.displayOrder }}
        </div>
        <div class="one-cell center-text center-self">
          {{ scoringCategory.moveNumberFirstDisplay }}
        </div>
        <div class="one-cell center-text center-self">
          {{ scoringCategory.moveNumberLastDisplay }}
        </div>
      </mat-expansion-panel-header>
      @if (editScoringCategoryId === scoringCategory.id) {
      <div class="sub-container">
        <app-admin-scoring-options [scoringCategoryId]="scoringCategory.id"
          [canEdit]="canEdit"></app-admin-scoring-options>
      </div>
      }
    </mat-expansion-panel>
    }
  </mat-accordion>
</div>
}

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
